import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts'

// yLabel/xLabel render axis titles with units (e.g. "mph", "vehicles", "Date").
export const MetricChart = ({ title, data, xKey, yKey, kind = 'line', unit = '', yLabel = '', xLabel = '', height = 240 }) => {
  const margin = { top: 8, right: 16, left: yLabel ? 6 : -12, bottom: xLabel ? 18 : 0 }
  const xAxis = (
    <XAxis dataKey={xKey} tick={{ fontSize: 10 }} interval="preserveStartEnd"
      label={xLabel ? { value: xLabel, position: 'insideBottom', offset: -6, fontSize: 11 } : undefined} />
  )
  const yAxis = (
    <YAxis tick={{ fontSize: 10 }}
      label={yLabel ? { value: yLabel, angle: -90, position: 'insideLeft', style: { textAnchor: 'middle', fontSize: 11 } } : undefined} />
  )
  return (
    <div className="tm-chart">
      <div className="tm-chart-title">{title}</div>
      <ResponsiveContainer width="100%" height={height}>
        {kind === 'bar' ? (
          <BarChart data={data} margin={margin}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.1)" />
            {xAxis}{yAxis}
            <Tooltip formatter={v => [`${v}${unit}`, title]} />
            <Bar dataKey={yKey} fill="#4fc3f7" isAnimationActive={false} />
          </BarChart>
        ) : (
          <LineChart data={data} margin={margin}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.1)" />
            {xAxis}{yAxis}
            <Tooltip formatter={v => [`${v}${unit}`, title]} />
            {/* Static dots (not just activeDot on hover) so a lone/sparse day -- e.g. a single
                day of traffic in the range -- is visible in the chart and the PDF/PPTX export,
                where a one-point line draws no segment. Nulls are skipped, so no dots on gaps. */}
            <Line type="monotone" dataKey={yKey} stroke="#4fc3f7" strokeWidth={2} dot={{ r: 2.5 }} isAnimationActive={false} />
          </LineChart>
        )}
      </ResponsiveContainer>
    </div>
  )
}
